/**
 * Gravity News Blog Listing Block - JavaScript
 * Handles client-side filtering by category
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const newsListingBlocks = document.querySelectorAll('.gravity-news-blog-listing:not([data-initialized])');
    
    newsListingBlocks.forEach(function(block) {
      // Mark block as initialized to prevent double initialization
      block.setAttribute('data-initialized', 'true');
      
      const uuid = block.dataset.uuid;
      const grid = block.querySelector('.gravity-news-blog-listing__grid');
      const cards = grid ? grid.querySelectorAll('.gravity-news-blog-listing__card') : [];
      
      // Exit if grid or cards not found
      if (!grid || cards.length === 0) {
        console.warn('Gravity News Blog Listing: Grid or cards not found');
        return;
      }
      
      // Current filter state
      let activeFilter = 'all';
      
      // Function to filter cards
      function filterCards(filter) {
        activeFilter = filter;
        
        let visibleCount = 0;
        cards.forEach(function(card) {
          const cardCategory = card.dataset.category || '';
          
          // Split cardCategory into array of categories (space-separated)
          const cardCategories = cardCategory ? cardCategory.trim().split(/\s+/) : [];
          
          if (filter === 'all' || cardCategories.includes(filter)) {
            card.style.display = 'flex';
            visibleCount++;
            
            // Update category text based on filter
            const categoryElement = card.querySelector('.gravity-news-blog-listing__category');
            if (categoryElement) {
              if (filter === 'all') {
                // Restore original category
                const originalCategory = card.dataset.originalCategory || '';
                categoryElement.textContent = originalCategory;
              } else {
                // Find and display the filtered category name
                const categoryMapping = card.dataset.categoryNames || '';
                if (categoryMapping) {
                  const mappings = categoryMapping.split(',');
                  let foundCategoryName = null;
                  
                  mappings.forEach(function(mapping) {
                    const parts = mapping.split(':');
                    if (parts.length === 2 && parts[0] === filter) {
                      foundCategoryName = parts[1];
                    }
                  });
                  
                  if (foundCategoryName) {
                    categoryElement.textContent = foundCategoryName;
                  }
                }
              }
            }
          } else {
            card.style.display = 'none';
          }
        });
        
        // Show/hide no results message
        let noResultsMessage = block.querySelector('.gravity-news-blog-listing__no-results');
        if (visibleCount === 0) {
          if (!noResultsMessage) {
            noResultsMessage = document.createElement('div');
            noResultsMessage.className = 'gravity-news-blog-listing__no-results';
            noResultsMessage.textContent = 'No results found for this filter';
            grid.appendChild(noResultsMessage);
          }
          noResultsMessage.style.display = 'flex';
        } else {
          if (noResultsMessage) {
            noResultsMessage.style.display = 'none';
          }
        }
      }

      // Update URL hash without adding history entries
      function updateHash(filter) {
        var encoded = encodeURIComponent(filter || 'all');
        if (history.replaceState) {
          history.replaceState(null, null, '#' + encoded);
        } else {
          window.location.hash = encoded;
        }
      }
      
      // Filter tabs (Tablet/Desktop)
      const tabs = block.querySelectorAll('.gravity-news-blog-listing__tab');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const filter = this.dataset.filter || 'all';
          
          // Update active tab
          tabs.forEach(function(t) {
            t.classList.remove('gravity-news-blog-listing__tab--active');
          });
          this.classList.add('gravity-news-blog-listing__tab--active');
          
          // Update dropdown text (mobile)
          const dropdownText = block.querySelector('.gravity-news-blog-listing__dropdown-text');
          if (dropdownText) {
            dropdownText.textContent = this.textContent.trim();
          }
          const dropdownItems = block.querySelectorAll('.gravity-news-blog-listing__dropdown-item');
          dropdownItems.forEach(function(item) {
            if (item.dataset.filter === filter) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
            }
          })
          // Filter cards
          filterCards(filter);
          updateHash(filter);
        });
      });
      
      // Mobile Filter Dropdown
      const dropdownButton = block.querySelector('.gravity-news-blog-listing__dropdown-button');
      const dropdownMenu = block.querySelector('.gravity-news-blog-listing__dropdown-menu');
      const dropdownItems = block.querySelectorAll('.gravity-news-blog-listing__dropdown-item');
      
      if (dropdownButton && dropdownMenu) {
        // Toggle dropdown
        dropdownButton.addEventListener('click', function(e) {
          e.stopPropagation();
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', !isExpanded);
          dropdownMenu.style.display = isExpanded ? 'none' : 'flex';
        });
        
        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
          if (!block.contains(e.target)) {
            dropdownButton.setAttribute('aria-expanded', 'false');
            dropdownMenu.style.display = 'none';
          }
        });
        
        // Handle dropdown item clicks
        dropdownItems.forEach(function(item) {
          item.addEventListener('click', function(e) {
            const filter = this.dataset.filter || 'all';
            const itemDropdown = e.currentTarget;

            dropdownItems.forEach(function(i) {
              i.classList.remove('active');
            })
            if (itemDropdown) {
              itemDropdown.classList.add('active');
            }
            // Update dropdown text
            const dropdownText = block.querySelector('.gravity-news-blog-listing__dropdown-text');
            if (dropdownText) {
              dropdownText.textContent = this.textContent.trim();
            }
            
            // Update tabs (if visible)
            tabs.forEach(function(tab) {
              if (tab.dataset.filter === filter) {
                tabs.forEach(function(t) {
                  t.classList.remove('gravity-news-blog-listing__tab--active');
                });
                tab.classList.add('gravity-news-blog-listing__tab--active');
              }
            });
            
            // Close dropdown
            dropdownButton.setAttribute('aria-expanded', 'false');
            dropdownMenu.style.display = 'none';
            
            // Filter cards
            filterCards(filter);
            updateHash(filter);
          });
        });
      }
      
      // Initialize: Restore filter from URL hash (if present)
      (function() {
        var initialFilter = 'all';
        if (window.location.hash && window.location.hash.length > 1) {
          initialFilter = decodeURIComponent(window.location.hash.substring(1));
        }

        // Check if the initialFilter matches any available tab or dropdown item
        var matchingTab = block.querySelector('.gravity-news-blog-listing__tab[data-filter="' + initialFilter + '"]');
        var matchingDropdownItem = block.querySelector('.gravity-news-blog-listing__dropdown-item[data-filter="' + initialFilter + '"]');

        if (matchingTab || matchingDropdownItem) {
          tabs.forEach(function(t) { t.classList.remove('gravity-news-blog-listing__tab--active'); });
          dropdownItems.forEach(function(i) { i.classList.remove('active'); });

          if (matchingTab) {
            matchingTab.classList.add('gravity-news-blog-listing__tab--active');
          }
          if (matchingDropdownItem) {
            matchingDropdownItem.classList.add('active');
            var dropdownText = block.querySelector('.gravity-news-blog-listing__dropdown-text');
            if (dropdownText) dropdownText.textContent = matchingDropdownItem.textContent.trim();
          } else {
            var activeTab = block.querySelector('.gravity-news-blog-listing__tab--active');
            var dropdownText = block.querySelector('.gravity-news-blog-listing__dropdown-text');
            if (dropdownText && activeTab) dropdownText.textContent = activeTab.textContent.trim();
          }

          filterCards(initialFilter);
        } else {
          filterCards('all');
          updateHash('all');
        }
      })();
    });
  });
})();
